import React from 'react';
import { UUID } from '../../../../types/shared/UUID';
import { DocumentsProvider } from '../../../../minipieces/documents/DocumentsProvider';
import { UploadsDocumentController } from '../../../../minipieces/documents/UploadsDocumentController';
import {
  IDocumentCategory,
  isHoldOpenOwnersPolicyName,
  isLongFormLendersPolicyName,
  isOwnersPolicyName,
  isShortFormLendersPolicyName,
} from '../../../../types/order/documents/IDocumentCategoryType';

export type TPolicyUploadType = 'shortForm' | 'longForm' | 'owner';

export interface IUploadPolicyContainerProps {
  orderId: UUID;
  documentCategories: IDocumentCategory[];
  policyUploadType: TPolicyUploadType;
}

export const UploadPolicyContainer: React.FC<IUploadPolicyContainerProps> = ({
  orderId,
  policyUploadType,
  documentCategories,
}) => {
  const { message, filterCallback } = determineProps()[policyUploadType];
  return (
    <DocumentsProvider
      orderID={orderId}
      documentCategories={documentCategories}
      creatableDocumentCategories={documentCategories.filter(filterCallback)}
    >
      <UploadsDocumentController message={message} />
    </DocumentsProvider>
  );
};

const determineProps = (): Record<
  TPolicyUploadType,
  { message: string; filterCallback: (option: IDocumentCategory) => boolean }
> => {
  return {
    shortForm: {
      message: "Upload Short Form Lender's Policy",
      filterCallback: ({ name, isLegacy }: IDocumentCategory) => {
        return !isLegacy && isShortFormLendersPolicyName(name);
      },
    },
    longForm: {
      message: "Upload Long Form Lender's Policy",
      filterCallback: ({ name, isLegacy }: IDocumentCategory) => {
        return !isLegacy && isLongFormLendersPolicyName(name);
      },
    },
    owner: {
      message: "Upload Owner's Policy",
      filterCallback: ({ name, isLegacy }: IDocumentCategory) => {
        return !isLegacy && (isHoldOpenOwnersPolicyName(name) || isOwnersPolicyName(name));
      },
    },
  };
};
